import React from 'react';
import { Button, Form, Row } from 'react-bootstrap';

const HeaderWithSearchForm = ({ onSearch, title, showNewRecordButton, onAdd, isDisabledSearchControl, placeHolder }) => {
  return (
    <header className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
      {
        onSearch && (
          <h6 className="font-weight-bold text-uppercase">{title}</h6>
        )
      }
      <Form onSubmit={onSearch}>
        <Row className="justify-content-end align-items-center flex-nowrap">
          <Form.Group controlId="search" className="mb-0">
            <Form.Control
              disabled={isDisabledSearchControl ? true : false}
              name="search"
              type="text"
              placeholder={placeHolder || "Buscar..."}
              className="rounded-pill"
            />
          </Form.Group>
          {showNewRecordButton && (
            <Button
              variant="light"
              size="sm"
              className="ml-1 mr-2"
              onClick={onAdd}>
              <i className="material-icons">add</i>
            </Button>
          )}
        </Row>
      </Form>
    </header>

  );
};

export default HeaderWithSearchForm;